import { render, staticRenderFns } from "./Staff12MonthPayrollSummary.vue?vue&type=template&id=084e2811"
import script from "./Staff12MonthPayrollSummary.vue?vue&type=script&lang=js"
export * from "./Staff12MonthPayrollSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports